import React, { useState } from "react";
import { styled } from "styled-components";
import { Button, Divider, Form, Input, message } from "antd";

import useResponsive from "../../hooks/useResponsive";
import TitleHeader from "../../components/Common/TitleHeader";
import {
  MainContainer,
  MainText,
  ResImage,
  SubText,
} from "../../helpers/StyledComponents";
import FileUpload from "../../components/Common/FileUpload";

const SupportUs = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [details, setDetails] = useState({});
  const { isMobile } = useResponsive();

  const onChangeDetails = (key, value) => {
    setDetails((prevDetails) => ({
      ...prevDetails,
      [key]: value,
    }));
  };

  console.log("details", details);

  const copyButton = (text) => {
    navigator.clipboard.writeText(text);
    messageApi.open({
      type: "success",
      content: `${text} has been copied to clipboard`,
      duration: 5,
    });
  };

  const formData = new FormData();
  formData.append("image", details.paySlip);
  console.log("formData", formData);
  return (
    <>
      {contextHolder}
      <MainContainer>
        <SupportContainer>
          <TitleHeader
            en="SUPPORT US"
            th="สนับสนุนพันธกิจและอธิษฐานเผื่อ SU THAILAND"
            center
          />
          <SubText>
            ท่านสามารถมีส่วนสนับสนุนพันธกิจของ SU Thailand
            โดยถวายทรัพย์ผ่านทางบัญชี <strong>“มูลนิธิพลังประจำวัน”</strong>
          </SubText>
          <Divider />

          <ResImage
            src="/webImg/su-qr-code-bank.jpeg"
            maxWidth="300"
            shadow
            border
          />
          <TextContainer>
            <SubText>
              เลขที่
              <Button
                style={{ margin: "0px 10px" }}
                type="primary"
                onClick={() => copyButton("1019209319")}
              >
                <div>101-9-20931-9</div>
              </Button>
              ธนาคารกรุงเทพ สาขาสีลม
            </SubText>

            <SubText align="center">
              กรุณาส่งหลักฐานการโอนเงิน/ใบนำฝากเงิน กรอกชื่อ-นามสกุล ที่อยู่
              เบอร์โทรศัพท์ และอีเมล ของท่านลงในแบบฟอร์มด้านล่าง
              <br />
              หรือส่งมาที่ contactsuthailand@gmail.com
              <br />
              หรือ Line:{" "}
              <Button
                style={{ background: "#06C755" }}
                type="primary"
                onClick={() => copyButton("@su-thailand")}
              >
                <div>@su-thailand</div>
              </Button>
              <br />
              เพื่อเราจะจัดส่งใบเสร็จรับเงินให้ท่านค่ะ
            </SubText>
          </TextContainer>
          <Divider />
          <MainText mb="15">กรอกรายละเอียด</MainText>
          <div style={{ marginBottom: "10px" }}>
            กรุณากรอกรายละเอียดบน Google Form โดยการคลิกที่ปุ่มด้านล่าง
          </div>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfl85h3DH3478eCz2RwW2bplnzKHPbGI4bQNU-wX84Bs-z-fw/viewform"
          >
            <Button type="primary">
              <div>กรอกรายละเอียดเพื่อรับใบเสร็จ</div>
            </Button>
          </a>
          {/* <Form
            size={"default"}
            style={{ width: `${isMobile ? "auto" : "500px"}` }}
          >
            <Form.Item label={<div>คำนำหน้าชื่อ</div>}>
              <Input
                onChange={(e) => onChangeDetails("title", e.target.value)}
              />
            </Form.Item>
            <Form.Item label={<div>ชื่อ - นามสกุล</div>}>
              <Input
                onChange={(e) => onChangeDetails("name", e.target.value)}
              />
            </Form.Item>
            <Form.Item label={<div>เบอร์โทรศัพท์</div>}>
              <Input
                onChange={(e) =>
                  onChangeDetails("recipientPhone", e.target.value)
                }
              />
            </Form.Item>
            <Form.Item label={<div>E-mail</div>}>
              <Input
                onChange={(e) => onChangeDetails("email", e.target.value)}
              />
            </Form.Item>
            <Form.Item label={<div>ที่อยู่สำหรับใบเสร็จ</div>}>
              <Input.TextArea />
            </Form.Item>
            <Form.Item name="dragger" valuePropName="fileList" noStyle>
              <FileUpload
                onFileChange={(file) => onChangeDetails("paySlip", file)}
              />
            </Form.Item>
            <Divider />
            <Button type="primary">
              <div>ส่งแบบฟอร์ม</div>
            </Button>
          </Form>
          <input
            type="file"
            accept="image/*"
            onChange={(file) => onChangeDetails("test", file)}
          /> */}
        </SupportContainer>
      </MainContainer>
    </>
  );
};

const SupportContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const TextContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 500px;
`;
export default SupportUs;
